module.exports = __webpack_public_path__ + "static/media/mr.9cfe4f56.svg";